import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { EMBEDDED_ROUTE_PREFIX } from "@/surfaces/surface";
import EmbeddedAccessDeniedPage from "./pages/access-denied";
import EmbeddedContextHomePage from "./pages/context-home";
import EmbeddedNewTicketPage from "./pages/new-ticket";
import EmbeddedTicketDetailPage from "./pages/ticket-detail";
import EmbeddedTicketsPage from "./pages/tickets";

/**
 * 嵌入端路由（设计 §5.2）。
 *
 * 用明确的 `/embedded` 路由空间，不用 `?embedded=true`——
 * 判定要早于 React（`main.tsx` 选 Token Provider），query 参数做不到这件事。
 * 路径前缀常量与 `detectSurface` 共用，避免改了路由忘了改判定（AR-28）。
 */
export const embeddedRoutes: RouteObject[] = [
  { index: true, element: <EmbeddedContextHomePage /> },
  { path: "context", element: <EmbeddedContextHomePage /> },
  { path: "tickets", element: <EmbeddedTicketsPage /> },
  { path: "tickets/new", element: <EmbeddedNewTicketPage /> },
  { path: "tickets/:ticketId", element: <EmbeddedTicketDetailPage /> },
  { path: "access-denied", element: <EmbeddedAccessDeniedPage /> },
  // 嵌入端的兜底停在嵌入根，绝不跳出 `/embedded`——那会把用户带进独立工作台的 OIDC 分支。
  { path: "*", element: <Navigate replace to={EMBEDDED_ROUTE_PREFIX} /> },
];
